import { ItemVariant, IContentAPIItemVariant } from "./ItemVariant";

export class ItemUpdateReportEntry {
    protected _instanceId: string;
    protected _updateType: ItemUpdateType;
    protected _itemVariants?: Array<ItemVariant>;    
    
    constructor(itemUpdateReportEntry: IItemUpdateReportEntry) {
        this._instanceId = itemUpdateReportEntry.instanceId;
        this._updateType = itemUpdateReportEntry.updateType;
        this._itemVariants = itemUpdateReportEntry.itemVariants?.map((itemVariant: Partial<IItemVariant>) => new ItemVariant(itemVariant));
    }
    
    serialize(): IContentAPIItemUpdateReportEntry {
        const itemUpdateReportEntry: IContentAPIItemUpdateReportEntry = {
            instanceId: this._instanceId,
            updateType: this._updateType
        };
        
        if (this._itemVariants !== undefined) {
            itemUpdateReportEntry.itemVariants = this._itemVariants.map((itemVariant: ItemVariant) => itemVariant.serialize());
        }
        
        return itemUpdateReportEntry;
    }
}

export interface IContentAPIItemUpdateReportEntry {
    instanceId: string;
    updateType: ItemUpdateType;
    itemVariants?: Array<IContentAPIItemVariant>;
}